import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-cfg-category-dialog',
  templateUrl: './cfg-category-dialog.component.html',
  styleUrls: ['./cfg-category-dialog.component.scss']
})
export class CfgCategoryDialogComponent implements OnInit {
  @Input() categoryData: any;
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  originalData: any;

  ngOnInit(): void {
    // Clono i dati per confronto "unchanged"
    this.originalData = JSON.parse(JSON.stringify(this.categoryData));
  }

  onSave() {
    if (this.isFormValid()) {
      this.save.emit(this.categoryData);
    }
  }

  onClose() {
    this.close.emit();
  }

  isFormValid(): boolean {
    return (
      this.categoryData?.name?.trim() &&
      this.categoryData?.code?.trim()
    );
  }

  isUnchanged(): boolean {
    return JSON.stringify(this.categoryData) === JSON.stringify(this.originalData);
  }
}
